import { render, staticRenderFns } from "./PostBox.vue?vue&type=template&id=3d3fbb42&scoped=true"
var script = {}
import style0 from "./PostBox.vue?vue&type=style&index=0&id=3d3fbb42&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d3fbb42",
  null
  
)

export default component.exports